export default __webpack_public_path__ + "static/media/emoji-gray.e5995134.svg";